import { createSlice } from "@reduxjs/toolkit"

type huddleStateType = {
  huddleGroups: Array<any>
  selectedHuddleGroup: null | any
  huddleRegions: Array<any>
  selectedHuddleRegion: null | any
  huddleOffices: Array<any>
  selectedHuddleOffice: null | any

  // data
  huddleData: any
  lastUpdatedDate: any
  auditData: any
  huddleSummaryData: any
  huddleSummaryKeyMetricsData: any
  huddleActiveOpportuntiesData: any
  providerSummaryData: any
  huddleHours: any
  huddleTodayAuditData: any
  huddleYesterdayAuditData: any
  huddleTomorrowAuditData: any

  //static
  huddleTabs: any
  selectedHuddleTab: any

  // PDF Data

  huddleSummaryTodayRows: any
  huddleSummaryYesterdayRows: any
  huddleSummaryFutureRows: any
  huddleSummaryKeyMetricsRows: any
  huddleActiveOpportunitiesRows: any
  providerSummaryRows: any
  todayAuditRows: any
  yesterdayAuditRows: any
}

const initialState: huddleStateType = {
  huddleGroups: [],
  selectedHuddleGroup: null,
  huddleRegions: [],
  selectedHuddleRegion: null,
  huddleOffices: [],
  selectedHuddleOffice: null,

  // data
  huddleData: [],
  lastUpdatedDate: [],
  huddleSummaryData: [],
  huddleSummaryKeyMetricsData: [],
  huddleActiveOpportuntiesData: [],
  providerSummaryData: [],
  huddleHours: 8,
  huddleTodayAuditData: [],
  huddleYesterdayAuditData: [],
  huddleTomorrowAuditData: [],

  // Audit state
  auditData: [],

  //static
  huddleTabs: [
    {
      index: 0,
      id: "huddle_summary",
      name: "Huddle Summary",
    },
    {
      index: 1,
      id: "active_opportunities",
      name: "Active Opportunities",
    },
    {
      index: 2,
      id: "provider_summary",
      name: "Provider Summary",
    },
    {
      index: 3,
      id: "patient_audit_summary",
      name: "Patient Audit Summary",
    },
  ],

  selectedHuddleTab: {
    index: 0,
    id: "huddle_summary",
    name: "Huddle Summary",
  },

  // Huddle PDF data

  huddleSummaryTodayRows: [],
  huddleSummaryYesterdayRows: [],
  huddleSummaryFutureRows: [],
  huddleSummaryKeyMetricsRows: [],
  huddleActiveOpportunitiesRows: [],
  providerSummaryRows: [],
  todayAuditRows: [],
  yesterdayAuditRows: [],
}

const huddleSlice = createSlice({
  name: "huddle",
  initialState,
  reducers: {
    setHuddleGroupList: (state, action) => {
      state.huddleGroups = action.payload
    },
    setSelectedGroup: (state, action) => {
      state.selectedHuddleGroup = action.payload
    },
    setHuddleRegionList: (state, action) => {
      state.huddleRegions = action.payload
    },
    setSelectedRegion: (state, action) => {
      state.selectedHuddleRegion = action.payload
    },
    setHuddleOfficeList: (state, action) => {
      state.huddleOffices = action.payload
    },
    setSelectedOffices: (state, action) => {
      state.selectedHuddleOffice = action.payload
    },
    setHuddleData: (state, action) => {
      state.huddleData = action.payload
    },
    setUpdatedHuddleHours: (state, action) => {
      state.huddleHours = action.payload
    },
    setAuditData: (state, action) => {
      state.auditData = action.payload
    },

    //static
    setSelectedHuddleTab: (state, action) => {
      state.selectedHuddleTab = action.payload
    },
    setLastUpdatedDate: (state, action) => {
      state.lastUpdatedDate = action.payload
    },
    setHuddleSummaryData: (state, action) => {
      state.huddleSummaryData = action.payload
    },
    setHuddleSummaryKeyMetricsData: (state, action) => {
      state.huddleSummaryKeyMetricsData = action.payload
    },
    setHuddleActiveOpportuntiesData: (state, action) => {
      state.huddleActiveOpportuntiesData = action.payload
    },
    setProviderSummaryData: (state, action) => {
      state.providerSummaryData = action.payload
    },
    setHuddleTodayAuditData: (state, action) => {
      state.huddleTodayAuditData = action.payload
    },
    setHuddleYesterdayAuditData: (state, action) => {
      state.huddleYesterdayAuditData = action.payload
    },
    setHuddleTomorrowAuditData: (state, action) => {
      state.huddleTomorrowAuditData = action.payload
    },

    // Huddle PDF data
    setHuddleSummaryTodayRows: (state, action) => {
      state.huddleSummaryTodayRows = action.payload
    },
    setHuddleSummaryYesterdayRows: (state, action) => {
      state.huddleSummaryYesterdayRows = action.payload
    },
    setHuddleSummaryFutureRows: (state, action) => {
      state.huddleSummaryFutureRows = action.payload
    },
    setHuddleSummaryKeyMetricsRows: (state, action) => {
      state.huddleSummaryKeyMetricsRows = action.payload
    },
    setHuddleActiveOpportuntiesRows: (state, action) => {
      state.huddleActiveOpportunitiesRows = action.payload
    },
    setProviderSummaryRows: (state, action) => {
      state.providerSummaryRows = action.payload
    },
    setTodayAuditRows: (state, action) => {
      state.todayAuditRows = action.payload
    },
    setYesterdayAuditRows: (state, action) => {
      state.yesterdayAuditRows = action.payload
    },
  },
})

export default huddleSlice.reducer

export const {
  setHuddleGroupList,
  setSelectedGroup,
  setHuddleRegionList,
  setSelectedRegion,
  setHuddleOfficeList,
  setSelectedOffices,
  setHuddleData,
  setLastUpdatedDate,
  setUpdatedHuddleHours,
  setAuditData,
  setSelectedHuddleTab,
  setHuddleSummaryData,
  setHuddleSummaryKeyMetricsData,
  setHuddleActiveOpportuntiesData,
  setProviderSummaryData,
  setHuddleTodayAuditData,
  setHuddleYesterdayAuditData,
  setHuddleTomorrowAuditData,
  setHuddleSummaryTodayRows,
  setHuddleSummaryYesterdayRows,
  setHuddleSummaryFutureRows,
  setHuddleSummaryKeyMetricsRows,
  setHuddleActiveOpportuntiesRows,
  setProviderSummaryRows,
  setTodayAuditRows,
  setYesterdayAuditRows,
} = huddleSlice.actions
